import React, { useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { BrandLogo, LinkedText, PageWrapper } from '@components';
import { ILegalDocument } from '@constants';
import { useTitle } from '@hooks';

// A public page: it is a standalone route, so it opens without signing in.
export const LegalPage: React.FC<{
  document: ILegalDocument;
  pageTitle: string;
}> = ({ document, pageTitle }) => {
  const setPageTitle = useTitle();

  useEffect(() => {
    setPageTitle(pageTitle);
  }, [setPageTitle, pageTitle]);

  return (
    <PageWrapper>
      {/* As Rocky's Terms of use: a white sheet on the grey page, and the whole page white on a
          phone. */}
      <Box
        minHeight="100dvh"
        pb={{ xs: 0, sm: 4 }}
        sx={(theme) => ({
          background: {
            xs: theme.palette.common.white,
            sm: theme.palette.background.backgroundPrimary,
          },
        })}
      >
        <Box pt={{ xs: 2, md: 3 }} pl={{ xs: 2, md: 6 }}>
          <BrandLogo />
        </Box>
        <Stack
          component="article"
          gap={3}
          width={{ xs: '100%', sm: '90%', lg: '100%' }}
          maxWidth={952}
          mx="auto"
          mt={{ xs: 0, sm: 3 }}
          px={{ xs: 2, sm: 8, lg: 12 }}
          pt={{ xs: 3, sm: 6 }}
          pb={6}
          borderRadius={{ xs: 0, sm: 3 }}
          bgcolor="common.white"
        >
          <Stack gap={1}>
            <Typography variant="h1" component="h1">
              {document.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Last updated: {document.lastUpdated}
            </Typography>
          </Stack>
          {document.sections.map((section) => (
            <Stack component="section" gap={1.5} key={section.heading}>
              <Typography variant="h3" component="h2">
                {section.heading}
              </Typography>
              {section.paragraphs.map((paragraph) => (
                <LinkedText key={paragraph} text={paragraph} variant="body1" />
              ))}
            </Stack>
          ))}
        </Stack>
      </Box>
    </PageWrapper>
  );
};
